var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.8433 12.3693C13.9743 12.2378 14.0479 12.0598 14.0479 11.8743C14.0479 11.6887 13.9743 11.5107 13.8433 11.3793L3.22545 0.761378C2.96836 0.502461 2.61894 0.356278 2.25406 0.354989C1.88919 0.353699 1.53874 0.497409 1.27982 0.754503C1.02091 1.0116 0.874725 1.36102 0.873436 1.72589C0.872147 2.09077 1.01586 2.44121 1.27295 2.70013L9.93832 11.3793C10.0693 11.5107 10.1429 11.6887 10.1429 11.8743C10.1429 12.0598 10.0693 12.2378 9.93832 12.3693L1.20772 21.1136C0.982462 21.3766 0.864753 21.715 0.878119 22.0611C0.891485 22.4071 1.03494 22.7354 1.27982 22.9803C1.5247 23.2251 1.85297 23.3686 2.19903 23.382C2.54508 23.3953 2.88343 23.2776 3.14647 23.0524L13.8433 12.3693Z","fill":"#FEFEFE"}));
}

ChevronRight.defaultProps = {"width":"15","height":"24","viewBox":"0 0 15 24","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
